import { render, staticRenderFns } from "./TicketsAssign.vue?vue&type=template&id=1549c2a0&"
import script from "./TicketsAssign.vue?vue&type=script&lang=js&"
export * from "./TicketsAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports